import { Dispatch, SetStateAction, useState } from 'react';

type HalfWeek = 'startOfWeek' | 'endOfWeek';
export type WeekChunk = 'wholeWeek' | HalfWeek;

const SLICE_PARAMS = {
  wholeWeek: [0, 7],
  startOfWeek: [0, 4],
  endOfWeek: [3, 7]
} as const;

export type SliceParams = (typeof SLICE_PARAMS)[WeekChunk];

export const useWeekChunkNavigation = ({
  isMobile,
  setWeekCount
}: {
  isMobile: boolean;
  setWeekCount: Dispatch<SetStateAction<number>>;
}) => {
  const [halfWeek, setHalfWeek] = useState<HalfWeek>('startOfWeek');
  const weekChunk: WeekChunk = isMobile ? halfWeek : 'wholeWeek';

  const goForward = () => {
    if (weekChunk === 'startOfWeek') {
      setHalfWeek('endOfWeek');
      return;
    }
    setHalfWeek('startOfWeek');
    setWeekCount((o) => o + 1);
  };

  const goBackward = () => {
    if (weekChunk === 'endOfWeek') {
      setHalfWeek('startOfWeek');
      return;
    }
    if (weekChunk === 'startOfWeek') setHalfWeek('endOfWeek');
    setWeekCount((o) => o - 1);
  };

  return {
    sliceParams: SLICE_PARAMS[weekChunk],
    isFirstChunk: weekChunk !== 'endOfWeek',
    goForward,
    goBackward
  };
};
